<template>
  <g
    data-glint-group
    transform="translate(-20 -20) scale(0.453125)"
    pointer-events="none"
    aria-hidden="true">
    <path
      data-glint="cutout"
      style="fill: #2a2925; --glint-delay: calc(var(--glint-cycle) * 0)"
      d="m129 116 3 4 11-1v1l-7 1v6l7-2 3-1v6l-17-1v-4Z" />
    <path
      data-glint="cutout"
      style="fill: #23211d; --glint-delay: calc(var(--glint-cycle) * 0)"
      d="M162 75h4v13h-2v3h-3v-3h2v-8h-6l-1 4-5 4v-6l-3-1 6-2 1-2Z" />
    <path
      data-glint="cutout"
      style="fill: #31302c; --glint-delay: calc(var(--glint-cycle) * 0.0066)"
      d="M93 146h5l2 4h-6l-2 10h-6l1-7 4-5Z" />
    <path
      data-glint="cutout"
      style="fill: #33322e; --glint-delay: calc(var(--glint-cycle) * 0.1357)"
      d="M208 101h9l2 2 5-1 4-1 2 10v4h-5v-8l-3-1-16-1v-3Z" />
    <path
      data-glint="cutout"
      style="fill: #325758; --glint-delay: calc(var(--glint-cycle) * 0.2008)"
      d="m96 255 10 1-1 2H88l-1 4h8l1 4H86v-10Z" />
    <path
      data-glint="cutout"
      style="fill: #3a6664; --glint-delay: calc(var(--glint-cycle) * 0.2441)"
      d="m287 83 4 1v2l4-2-1 12 3 1 1 3h-4l-1 3-7-1 2 4v4l-4-1h2l-1-8h2Z" />
    <path
      data-glint="cutout"
      style="fill: #315957; --glint-delay: calc(var(--glint-cycle) * 0.2686)"
      d="M162 212h6v10l-1 6-3 1-1 6h-2v-10l3-1v-2l-3-1Z" />
    <path
      data-glint="cutout"
      style="fill: #426f70; --glint-delay: calc(var(--glint-cycle) * 0.3318)"
      d="m304 120 16 1v4h-5v-2h-4v3h-7Z" />
    <path
      data-glint="cutout"
      style="fill: #2b4547; --glint-delay: calc(var(--glint-cycle) * 0.3732)"
      d="M142 291h5l-1 12h-6l1-9Z" />
    <path
      data-glint="cutout"
      style="fill: #3e6866; --glint-delay: calc(var(--glint-cycle) * 0.4119)"
      d="M286 165h10l4 3v3l-14-1Z" />
    <path
      data-glint="cutout"
      style="fill: #40726f; --glint-delay: calc(var(--glint-cycle) * 0.4288)"
      d="m194 283 5 1 1 3-2 3-7 3h-5v-9Z" />
    <path
      data-glint="cutout"
      style="fill: #325456; --glint-delay: calc(var(--glint-cycle) * 0.5297)"
      d="M348 167h4v4l4 2-2 5h-2v3h-4Z" />
    <path
      data-glint="cutout"
      style="fill: #572522; --glint-delay: calc(var(--glint-cycle) * 0.5523)"
      d="M144 382h3v8l8-1 1 3-2 7 2 4h-5l-1-7-1-1-9-1 1-10Z" />
    <path
      data-glint="cutout"
      style="fill: #5d2826; --glint-delay: calc(var(--glint-cycle) * 0.557)"
      d="m201 334 15 1 2 2-21 1v6h7v1h-15l2-2 1-7Z" />
    <path
      data-glint="cutout"
      style="fill: #5b2825; --glint-delay: calc(var(--glint-cycle) * 0.6579)"
      d="M222 364h3v8l-1 4h-6l1-10Z" />
    <path
      data-glint="cutout"
      style="fill: #31302c; --glint-delay: calc(var(--glint-cycle) * 0.6777)"
      d="M250 338h11l4 2 1-1h6l-2 5-1 1h-16l-3-1-1-5Z" />
    <path
      data-glint="cutout"
      style="fill: #7f393c; --glint-delay: calc(var(--glint-cycle) * 0.7314)"
      d="M393 239h5l-1 3-7 1-1 10h-5v-7h2v-6Z" />
    <path
      data-glint="cutout"
      style="fill: #5a2623; --glint-delay: calc(var(--glint-cycle) * 0.7484)"
      d="M220 411h4v6h4v3l-6 2h-4v-6h2Z" />
    <path
      data-glint="cutout"
      style="fill: #542323; --glint-delay: calc(var(--glint-cycle) * 0.7691)"
      d="M368 273h7v2l-2 1-1 4h7v3l-7 1-4 1Z" />
    <path
      data-glint="cutout"
      style="fill: #22211d; --glint-delay: calc(var(--glint-cycle) * 0.7795)"
      d="M280 364h6v4h-2l-1 16h-2v-9l-3-1v-2h2Z" />
    <path
      data-glint="cutout"
      style="fill: #6c3031; --glint-delay: calc(var(--glint-cycle) * 0.8388)"
      d="m447 242 2 3 3 1v7h-8l1-9-3-1Z" />
    <path
      data-glint="cutout"
      style="fill: #302f2b; --glint-delay: calc(var(--glint-cycle) * 0.8935)"
      d="m317 402 10 1v7h-10l-2-6Z" />
    <path
      data-glint="cutout"
      style="fill: #803639; --glint-delay: calc(var(--glint-cycle) * 0.9227)"
      d="M444 284h4v5l-9 4-3 7-3-1 1-5 2-7h4l1-2Z" />
    <path
      data-glint="cutout"
      style="fill: #33322e; --glint-delay: calc(var(--glint-cycle) * 1)"
      d="M392 376h6l-1 4h-6l-2 9h-5l-1-3 2-1 2-7 5 1Z" />
  </g>
</template>

<style>
  g[data-glint-group] {
    --glint-cycle: calc(var(--realness-cycle, 90s) * 0.1);
  }

  path[data-glint] {
    opacity: 0;
    filter: brightness(1.85) saturate(1.35);
    animation-name: realness-glint-flash;
    animation-duration: var(--glint-cycle);
    animation-delay: var(--glint-delay, 0s);
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    animation-play-state: paused;
  }

  @keyframes realness-glint-flash {
    0%,
    100% {
      opacity: 0;
    }
    2% {
      opacity: 0;
    }
    5% {
      opacity: 0.9;
    }
    8% {
      opacity: 0;
    }
  }
</style>
